import VideoHandle from './VideoHandle';
VideoHandle.install = function(Vue) {
  Vue.component(VideoHandle.name, VideoHandle);
};

export default VideoHandle;
